import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import drinkIcon from '../../images/drinkIcon.svg';
import exploreIcon from '../../images/exploreIcon.svg';
import mealIcon from '../../images/mealIcon.svg';
import './styles.css';

class Footer extends Component {
  render() {
    const { location } = this.props;
    const currentPath = location ? location.pathname : '';

    return (
      <footer className="footer-glass-wrapper" data-testid="footer" role="navigation" aria-label="Menu principal inferior">
        <nav className="footer-nav-grid">
          <Link
            className={`footer-nav-item ${currentPath.includes('/bebidas') ? 'active' : ''}`}
            to="/bebidas"
            aria-label="Ir para a seção de bebidas"
          >
            <img
              src={ drinkIcon }
              alt=""
              aria-hidden="true"
              data-testid="drinks-bottom-btn"
            />
            <span className="footer-nav-label">Bebidas</span>
          </Link>

          <Link
            className={`footer-nav-item ${currentPath.includes('/explorar') ? 'active' : ''}`}
            to="/explorar"
            aria-label="Ir para a seção explorar"
          >
            <img
              src={ exploreIcon }
              alt=""
              aria-hidden="true"
              data-testid="explore-bottom-btn"
            />
            <span className="footer-nav-label">Explorar</span>
          </Link>

          <Link
            className={`footer-nav-item ${currentPath.includes('/comidas') ? 'active' : ''}`}
            to="/comidas"
            aria-label="Ir para a seção de comidas"
          >
            <img
              src={ mealIcon }
              alt=""
              aria-hidden="true"
              data-testid="food-bottom-btn"
            />
            <span className="footer-nav-label">Comidas</span>
          </Link>
        </nav>
      </footer>
    );
  }
}

Footer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

Footer.defaultProps = {
  location: { pathname: '' },
};

export default withRouter(Footer);

